// English dictionary — global UI
export const en = {
  nav: {
    home: 'Home',
    house: 'The House',
    collections: 'Collections',
    reverie: 'Rêverie',
    fabrication: 'Craftsmanship',
    contact: 'Contact',
    legal: 'Legal notice',
    privacy: 'Privacy policy',
    menu: 'Menu',
    close: 'Close',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  footer: {
    navigation: 'Navigation',
    contact: 'Contact',
    follow: 'Follow us',
    rights: 'All rights reserved',
  },
  common: {
    back: 'Back',
    discover: 'Discover',
    contactUs: 'Write to us',
    loading: 'Loading...',
    close: 'Close',
    untitled: 'Untitled',
  },
  home: {
    heroTagline: 'Born from Memory',
    heroDescription: 'Jewellery conceived as fragments of memory.',
    phase2: 'It all starts with a stone...',
    sylvieIntroLine1: 'An emotion, a light, a memory,',
    sylvieIntroLine2: 'a moment lived somewhere in the world...',
    sylvieTitle: 'The stone becomes a jewel...',
    savoirFaireLine1: 'To be worn',
    savoirFaireLine2: 'To be treasured',
    ctaText1: 'Pieces shaped by the stones we choose.',
    ctaText2: 'Confidential, numbered editions.',
    ctaButton: 'Discover the collection',
  },
  collection: {
    title: 'Rêverie',
    introP1Part1: ' is a collection of suspended moments. It evokes those instants when the mind drifts...',
    introP2: 'In Bangkok, where Pernety\'s story began, we first dared to dream.',
    customP1: 'Pieces crafted around carefully chosen stones, made to order.',
    customP2: 'Stone sourcing available on request.',
    // Product overlay
    back: 'Back',
    stone: 'Stone',
    origin: 'Origin',
    size: 'Size',
    availability: 'Availability',
    onOrder: 'Made to order',
    pieceCount: (n) => `${n} piece${n > 1 ? 's' : ''}`,
    relatedTitle: 'Pairs beautifully with',
    ctaContact: 'Write to us',
    untitledPiece: 'Title to be defined',
    descriptionPlaceholder: 'Description to be added via the admin',
    notFound: 'Piece not found',
    backToCollection: 'Back to the collection',
  },
  legal: {
    heroTitle: 'Legal notice',
    lastUpdate: 'Last updated',
    s1Title: '1. Publisher',
    s1Intro: 'The website',
    s1Edited: 'is published by:',
    brand: 'Trade name',
    responsible: 'Person in charge',
    legalStatus: 'Legal status',
    address: 'Registered office address',
    siret: 'SIRET number',
    apeCode: 'APE/NAF code',
    vat: 'EU VAT number',
    capital: 'Share capital',
    rcs: 'Trade register (RCS)',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    s2Title: '2. Publication director',
    s2P: (name, role) => `The publication director of the website is ${name}, in their capacity as ${role}.`,
    s3Title: '3. Hosting',
    s3Intro: 'The website is hosted by:',
    hostCompany: 'Company',
    hostAddress: 'Address',
    hostPhone: 'Phone',
    hostWebsite: 'Website',
    s4Title: '4. Intellectual property',
    s4P1: 'All elements present on the website (texts, photographs, illustrations, graphics, logos, trademarks, layouts, creations, videos, sounds, and more generally all content) are the exclusive property of Pernety or its partners, and are protected by French and international intellectual property law.',
    s4P2: 'Any reproduction, representation, modification, publication, transmission, distortion, in whole or in part, of the website or its content, by any means and on any medium, is forbidden without prior written authorisation from Pernety. Any unauthorised exploitation would constitute infringement, punishable under articles L.335-2 et seq. of the French Intellectual Property Code.',
    s4P3: (owner) => `The "Pernety" trademark and associated logo are the property of ${owner}.`,
    s5Title: '5. Credits',
    creditsDev: 'Design and development',
    creditsPhoto: 'Photography',
    creditsDesign: 'Graphic identity',
    s6Title: '6. Limitation of liability',
    s6P1: 'Pernety strives to ensure the accuracy and updating of the information published on the website to the best of its ability. However, Pernety cannot guarantee the accuracy, precision or completeness of the information made available on the website.',
    s6P2: 'Consequently, Pernety disclaims all liability for any imprecision, inaccuracy or omission relating to information available on the website, as well as for any damage resulting from fraudulent intrusion by a third party.',
    s6P3: 'The user acknowledges using the website at their own risk.',
    s7Title: '7. Hyperlinks',
    s7P1: 'The website may contain hyperlinks to other websites. Pernety exercises no control over these sites and assumes no responsibility for their content, availability or practices regarding personal data.',
    s7P2: 'Creating links to the website requires the prior written authorisation of Pernety.',
    s8Title: '8. Personal data',
    s8P: 'The processing of personal data collected on the website is detailed in the',
    s8Link: 'Privacy policy',
    s8End: ', which forms an integral part of the present legal notice.',
    s9Title: '9. Applicable law and jurisdiction',
    s9P: 'The present legal notice is governed by French law. In the event of a dispute relating to the use of the website, and failing amicable resolution, the French courts shall have exclusive jurisdiction.',
    s10Title: '10. Contact',
    s10P: (email) => `For any question relating to the present legal notice, you may write to us at ${email} or via the contact form.`,
    s10Form: 'contact form',
  },
  privacy: {
    heroTitle: 'Privacy policy',
    lastUpdate: 'Last updated',
    preambleTitle: 'Preamble',
    preambleP1: 'This privacy policy is intended to inform you, transparently, about how Pernety collects, uses and protects your personal data when you visit the website',
    preambleP1End: ' or interact with us.',
    preambleP2: 'This policy complies with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 ("GDPR") and with the French "Informatique et Libertés" Act of 6 January 1978 as amended.',
    s1Title: '1. Data controller',
    s1Intro: 'The controller of your personal data is:',
    s1Identity: 'Identity',
    s1Status: 'Status',
    s1Address: 'Address',
    s1Siret: 'SIRET',
    s1Email: 'Email',
    s1Phone: 'Phone',
    s1NoDpo: 'Pernety has not appointed a Data Protection Officer (DPO) as appointment is not mandatory given the activity and volume of data processed. Any request relating to your personal data may be addressed directly to the data controller at the contact details above.',
    s2Title: '2. Personal data collected',
    s2Intro: 'The following data may be collected on the website:',
    s2_1Title: '2.1 Via the contact form',
    s2_1L1: '- First and last name',
    s2_1L2: '- Email address',
    s2_1L3: '- Phone number (optional)',
    s2_1L4: '- Type of request (information, custom order, appointment, other)',
    s2_1L5: '- Desired type of jewellery, budget, occasion (optional)',
    s2_1L6: '- Message content',
    s2_2Title: '2.2 Technical data',
    s2_2L1: '- IP address (collected by server logs for security purposes)',
    s2_2L2: '- Browser type and operating system',
    s2_2L3: '- Pages visited and date/time of visit',
    s2NoSensitive: 'No sensitive data within the meaning of article 9 of the GDPR (racial or ethnic origin, political opinions, religious beliefs, health data, etc.) is collected.',
    s3Title: '3. Purposes of processing',
    s3Intro: 'Your data is collected and processed for the following purposes:',
    s3L1: 'To respond to contact, quotation or appointment requests sent via the form',
    s3L2: 'To manage the client relationship and any custom orders',
    s3L3: 'To ensure the security, availability and proper functioning of the website',
    s3L4: 'To comply with our legal and regulatory obligations (in particular accounting and tax)',
    s3End: 'Your data is not subject to any automated decision-making or profiling.',
    s4Title: '4. Legal bases for processing',
    s4Intro: 'In accordance with article 6 of the GDPR, the processing of your data is based on the following legal grounds:',
    s4L1Strong: 'Consent',
    s4L1: ' (art. 6.1.a): when you fill in and submit the contact form',
    s4L2Strong: 'Performance of a contract or pre-contractual measures',
    s4L2: ' (art. 6.1.b): to follow up on your quotation or order requests',
    s4L3Strong: 'Legitimate interest',
    s4L3: ' (art. 6.1.f): to ensure the security of the website and our information system',
    s4L4Strong: 'Legal obligation',
    s4L4: ' (art. 6.1.c): to comply with the retention periods imposed by law (in particular for accounting purposes)',
    s5Title: '5. Retention period',
    s5Intro: 'Your data is retained for the following periods:',
    s5L1Strong: 'Contact messages:',
    s5L1: ' 3 years from the last exchange, in accordance with CNIL recommendations on prospecting',
    s5L2Strong: 'Client data (orders):',
    s5L2: ' 5 years after the end of the contractual relationship, in accordance with accounting obligations (art. L.123-22 of the French Commercial Code)',
    s5L3Strong: 'Connection logs:',
    s5L3: ' 12 months maximum (CNIL recommendation)',
    s5End: 'Beyond these periods, data is either deleted or anonymised for statistical purposes.',
    s6Title: '6. Recipients of your data',
    s6P1: 'Your data is intended exclusively for Pernety and is never sold, leased or transferred to third parties for commercial purposes.',
    s6P2: 'However, it may be communicated to the following recipients, strictly within the limits of their missions:',
    s6L1Strong: 'Technical subcontractors',
    s6L1: ' acting on instructions from the data controller, under a contract compliant with article 28 of the GDPR:',
    s6OvhStrong: 'OVH SAS',
    s6Ovh: ' (server hosting), France',
    s6MongoStrong: 'MongoDB Atlas',
    s6Mongo: ' (database hosting), ',
    s6Auth: 'Administrative or judicial authorities',
    s6AuthEnd: ', upon legal request',
    s7Title: '7. Data transfers outside the European Union',
    s7P1: 'If the MongoDB Atlas database is hosted in a country outside the European Union, this transfer is governed by the',
    s7P1Strong: 'Standard Contractual Clauses',
    s7P1End: ' approved by the European Commission, ensuring a level of protection equivalent to the GDPR.',
    s7P2: 'The website also loads typographic fonts from Google Fonts (Playfair Display, Cormorant Garamond). This may result in your IP address being transmitted to Google LLC servers. These transfers are governed by the',
    s7P2Strong: 'Data Privacy Framework',
    s7P2End: ' (DPF) between the EU and the United States.',
    s8Title: '8. Your rights',
    s8Intro: 'In accordance with articles 15 to 22 of the GDPR, you have the following rights over your personal data:',
    s8L1Strong: 'Right of access',
    s8L1: ': to obtain confirmation that your data is being processed and to receive a copy',
    s8L2Strong: 'Right of rectification',
    s8L2: ': to have inaccurate or incomplete data corrected',
    s8L3Strong: 'Right to erasure',
    s8L3: ' ("right to be forgotten"): to have your data deleted in cases provided for by law',
    s8L4Strong: 'Right to restriction of processing',
    s8L4: ': to temporarily suspend the processing of your data',
    s8L5Strong: 'Right to object',
    s8L5: ': to object to processing on grounds relating to your particular situation',
    s8L6Strong: 'Right to data portability',
    s8L6: ': to receive your data in a structured, machine-readable format',
    s8L7Strong: 'Right to set post-mortem directives',
    s8L7: ' regarding the fate of your data after death',
    s8L8Strong: 'Right to withdraw your consent',
    s8L8: ' at any time, without affecting the lawfulness of prior processing',
    s8End: (email) => `To exercise these rights, you may contact us at ${email} providing proof of identity. We undertake to respond within one month of receipt of your request, in accordance with article 12 of the GDPR.`,
    s9Title: '9. Complaint to the CNIL',
    s9P: 'If, after contacting us, you consider that your rights have not been respected, you may file a complaint with the French Data Protection Authority (CNIL):',
    s9Address: 'Address',
    s9Phone: 'Phone',
    s9Web: 'Website',
    s10Title: '10. Data security',
    s10Intro: 'Pernety implements appropriate technical and organisational measures to protect your data against loss, destruction, disclosure, alteration or unauthorised access, in particular:',
    s10L1: 'Encryption of communications via HTTPS (SSL/TLS certificate)',
    s10L2: 'Cryptographic hashing of administrator passwords (bcrypt)',
    s10L3: 'Access restricted to authorised persons only',
    s10L4: 'Regular backups and hosting on secure infrastructure',
    s10L5: 'HTTP security headers (Helmet)',
    s10End: 'In the event of a data breach likely to result in a high risk to your rights and freedoms, you will be informed in accordance with article 34 of the GDPR.',
    s11Title: '11. Modifications to this policy',
    s11P: 'This policy may be modified at any time, in particular to reflect changes in legislation or in Pernety\'s activities. The date of last update appears at the top of this document. We invite you to consult it regularly.',
    s12Title: '12. Contact',
    s12P1: (email) => `For any question relating to this policy or to the processing of your personal data, you may write to us at ${email} or via the contact form.`,
    s12Form: 'contact form',
    s12P2: 'The website\'s legal notice complements this policy.',
    s12LegalLink: 'legal notice',
    placeholder: (hint) => `[To be completed: ${hint}]`,
  },
  login: {
    privateArea: 'Private area',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    submit: 'Sign in',
    submitting: 'Signing in...',
    footer: 'Site under development',
  },
  contact: {
    heroTitle: 'Every jewel begins with a conversation',
    infoLead: 'Every message is read with care.',
    emailLabel: 'Email',
    instagramLabel: 'Instagram',
    appointmentLabel: 'By appointment',
    // Form
    fullName: 'Full name',
    fullNamePlaceholder: 'Your name',
    emailPlaceholder: 'you@email.com',
    phone: 'Phone',
    phonePlaceholder: 'Your number',
    yourMessage: 'Your message',
    requiredHint: '* Required fields',
    submit: 'Send',
    submitting: 'Sending',
    // Validation
    errorName: 'Please enter your name',
    errorEmailMissing: 'Please enter your email',
    errorEmailInvalid: 'Please enter a valid email address',
    errorMessage: 'Please write a message',
    errorGeneric: 'Something went wrong. Please try again or write to us directly at contact@pernetyparis.com',
    // Success
    successTitle: 'Message sent',
    successDearClient: 'dear guest',
    successThanks: (name) => `Thank you for your message, ${name}.`,
    successReply: 'I will get back to you as soon as possible to arrange an appointment.',
    sendAnother: 'Send another message',
  },
  fabrication: {
    heroTitle: 'Craftsmanship',
    heroSubtitle: 'An artisanal journey',
    s1Title: 'It all begins with a stone,',
    s1P1: 'Our stones are sourced in the markets of Southeast Asia, particularly in Bangkok, the world\'s hub for coloured stones and a longstanding centre of lapidary and jewellery expertise.',
    s1P2: 'Between my Parisian studio where imagination is given free rein, and that of my partner jeweller in Thailand, each piece comes to life around the stone that inspires it.',
    s2Title: 'In full transparency.',
    s2Intro: 'At Pernety, transparency and trust are at the heart of everything we do.',
    s2P1: 'Every piece comes with a card detailing the nature of its stone, its origin, and care recommendations.',
    s2P2: 'I personally select each stone from trusted partners.',
    s2P3: 'Exceptional stones come with a certificate issued by an independent laboratory.',
    s2P4: 'The gold we use comes from controlled supply chains. Our approach reflects a commitment to responsibility and continuous improvement, with the aim of ever more virtuous sourcing.',
  },
  laMaison: {
    heroTitle: 'The House',
    identityP1Start: 'Pernety is a jewellery house that imagines pieces conceived as ',
    identityP1Em: 'fragments of memory',
    identityP1Middle: '. ',
    identityP1Strong: 'Each creation is born from a memory',
    identityP1End: ', from an emotion, from a particular light, from a moment lived somewhere in the world.',
    identityP2: 'A heritage of the earth, our stones are chosen with care for their unique character and singular brilliance. Each piece becomes a cherished presence, made to be worn and to be passed down through generations.',
    paris: 'Paris',
    bangkok: 'Bangkok',
    world: 'The World',
    creatorTitle: 'The designer',
    creatorSubtitle: 'A vision guided by the stone...',
    bioP1: 'A gemmologist by training, I studied at the Laboratoire Français de Gemmologie in Paris, then at the Asian Institute of Gemological Studies in Bangkok, where I specialised in coloured stones.',
    bioP2: 'Curious and passionate, I continue to deepen my knowledge and refine my eye for gemstones. Each creation begins with a stone that particularly inspires me, around which the piece takes shape.',
  },
};
